module.exports = __webpack_public_path__ + "img/ICONO14.5af801f8.png";